import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import { useFormContext } from 'react-hook-form';

import {
    AGENT_LATEST_AGENT_VERSION,
    AGENT_MODEL_SHORT_DISPLAY_FIELD,
    AGENT_NAME_FIELD,
    AGENT_NETWORK_IPV4_EXTERNAL_FIELD,
    AGENT_NETWORK_IPV4_LOCAL_FIELD,
    AGENT_STATUS_FIELD,
    AGENT_TAGS_DISPLAY_FIELD,
} from '../../pages-admin/agents/AgentConstants';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { buildNetTestNowAgentPickerGridColumns } from './NetTestNowHelpers';
import AgentSelector from '../../form/AgentSelector';

const AGENTS_FIELD = 'agents';

export const initialSort = [{ property: AGENT_NAME_FIELD, direction: SORT_ASC }];

export function NetTestNowAgentsFormSection({
    formData,
    setAgentSelectionIsDirty,
    interfaceType,
    agentList,
    wirelessAgentList,
}) {
    const { watch } = useFormContext();
    const agents = watch('agents');
    const [theAgents, setTheAgents] = useState([]);

    const agentsToShow = (interfaceType === 'wireless' ? wirelessAgentList : agentList)?.filter((agent) =>
        theAgents?.selection ? theAgents.selection.includes(agent._id) : theAgents.includes(agent._id)
    );

    useEffect(() => {
        if (agents) {
            setTheAgents(agents);
        }
    }, [agents]);

    const agentsForSelection = agentList.filter((agent) => !agentsToShow?.includes(agent));
    const wirelessAgentsForSelection = wirelessAgentList.filter((agent) => !agentsToShow?.includes(agent));

    return (
        <AgentSelector
            fieldName={AGENTS_FIELD}
            gridColumns={buildNetTestNowAgentPickerGridColumns()}
            sorters={initialSort}
            dbSelected={formData[AGENTS_FIELD]}
            selectedAgents={agentsToShow}
            addButtonText={t`Add nPoints`}
            removeButtonText={t`Remove nPoints`}
            selectedEmptyGridText={t`There are no selected nPoints`}
            setSelectionIsDirty={setAgentSelectionIsDirty}
            agentList={interfaceType === 'wireless' ? wirelessAgentList : agentList}
            setTheAgents={setTheAgents}
            dataArray={interfaceType === 'wireless' ? wirelessAgentsForSelection : agentsForSelection}
            dataArraySearchFields={[
                AGENT_NAME_FIELD,
                AGENT_MODEL_SHORT_DISPLAY_FIELD,
                AGENT_STATUS_FIELD,
                AGENT_TAGS_DISPLAY_FIELD,
                AGENT_LATEST_AGENT_VERSION,
                AGENT_NETWORK_IPV4_LOCAL_FIELD,
                AGENT_NETWORK_IPV4_EXTERNAL_FIELD,
            ]}
        />
    );
}
